import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useLogout() {
    return useMutation({
        mutationFn: () => getAuthModule().actions.logout(),
    });
}
